module.exports = __webpack_public_path__ + "img/aeroplane.c700dcf5.svg";